import { z } from "zod";
import { SLOT_STATUS, VALIDATION_KEYS as VK } from "@fysaro/shared";

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const createAvailabilitySchema = z
  .object({
    professionalId: z.string().uuid(VK.GENERIC.UUID),
    dayOfWeek: z
      .number()
      .min(0, VK.AVAILABILITY.INVALID_DAY)
      .max(6, VK.AVAILABILITY.INVALID_DAY),
    startTime: z.string().regex(timeRegex, VK.AVAILABILITY.TIME_FORMAT),
    endTime: z.string().regex(timeRegex, VK.AVAILABILITY.TIME_FORMAT),
  })
  .strict()
  .refine((data) => data.startTime < data.endTime, {
    message: VK.AVAILABILITY.TIME_ORDER,
    path: ["endTime"], // El error aparecerá en el campo endTime
  });

export const updateAvailabilitySchema = z
  .object({
    professionalId: z.string().uuid(VK.GENERIC.UUID),
    dayOfWeek: z
      .number()
      .min(0, VK.AVAILABILITY.INVALID_DAY)
      .max(6, VK.AVAILABILITY.INVALID_DAY),
    startTime: z.string().regex(timeRegex, VK.AVAILABILITY.TIME_FORMAT),
    endTime: z.string().regex(timeRegex, VK.AVAILABILITY.TIME_FORMAT),
  })
  .strict()
  .refine((data) => data.startTime < data.endTime, {
    message: VK.AVAILABILITY.TIME_ORDER,
    path: ["endTime"], // El error aparecerá en el campo endTime
  });

export const getSlotsSchema = z.object({
  professionalId: z.string().uuid(VK.GENERIC.UUID),
  serviceId: z.string().uuid(VK.GENERIC.UUID),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, VK.AVAILABILITY.INVALID_DATE),
  duration: z.number().positive("La duración debe ser mayor a 0"),
});

export const getSlotsResponseSchema = z.object({
  date: z.string(),
  slots: z.array(
    z.object({
      time: z.string(),
      status: z.enum(SLOT_STATUS), // <-- Usa el objeto de dominio
    }),
  ),
});

export const availableDaysQuerySchema = z.object({
  clinicId: z.string().uuid(VK.GENERIC.UUID).optional(),
  // clinicId: z.preprocess(
  //   (val) => (val === "" || val === "null" ? undefined : val),
  //   z.string().uuid(VK.GENERIC.UUID).optional()
  // ),
  professionalId: z.string().uuid(VK.GENERIC.UUID),
  serviceId: z.string().uuid(VK.GENERIC.UUID),
  monthStr: z.string(),
});

export const availableHoursQuerySchema = z.object({
  clinicId: z.string().uuid(VK.GENERIC.UUID).optional(),
  professionalId: z.string().uuid(VK.GENERIC.UUID),
  serviceId: z.string().uuid(VK.GENERIC.UUID),
  date: z.string(),
  duration: z.number(),
});
